import { useSelector } from 'react-redux'
import { getOperatingHours } from 'redux/selectors/members'
import { OperatingHours } from 'types/member/member'

export const useHasOperatingHours = () => {
  const operatingHours: OperatingHours[] | null = useSelector(getOperatingHours)

  return !!operatingHours?.length
}
